<template>
  <section class="activity">
    <title-bg></title-bg>
    <ul class="activity-list">
      <li  class="activity-list-item" v-for="(item, index) in catList" :key="index" >
        <img :src="$root.sourceBaseUrl + item.cat_img" alt="" class="activity-list-item-image"  v-if="item.cat_url===null"  @click="redirectDetail(item.id)">
        <img :src="$root.sourceBaseUrl + item.cat_img" alt="" class="activity-list-item-image"  v-if="item.cat_url !== null"  @click="catURL(item.cat_url)">
        <span class="activity-list-item-title">{{item.cat_name}}</span>
      </li>
    </ul>
  </section>
</template>
<script>
import TitleBg from '../../../components/TitileBg'
export default {
  components: {
    TitleBg
  },
  data () {
    return {
      catList: [],
      loading: true,
    }
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.loading = true;
      this.$http.get(this.$root.apiBaseUrl + '?g=api&m=api2&a=get_schoolday_cat').then(function (response) {
        if (response.body.status == 1 && response.body.data != null) {
          console.log('.........'+response.body.data);
          this.catList = response.body.data;          
        }
        this.loading = false;
      }, function (reserror) {
        console.log(reserror);
      })
    },
    redirectDetail (id) {
      this.$router.push({
            name: 'CelebrationColumnSub',
            params: {
              catId: id
            }
		  });
    },
    catURL (id) {
      window.open(id);
    }
  }
}
</script>
<style lang="less" scoped>
.activity{
  flex-grow: 1;
  overflow: hidden;
  &-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 48px;
    margin-bottom: 100px;
    &-item{
      display: flex;
      flex-direction: column;
      margin-bottom: 33px;
      width:386px;
      height:188px;
      background:#ccc;
      &-image{
        width: 100%;
        height:135px;
      }
      &-title{
        height: 53px;
        line-height: 53px;
        background: #EFEFEF;
        text-align: center;
        font-size:13px;
        font-weight:400;
        color:rgba(0,0,0,1);
      }
    }
  }
}
</style>
